// The base META pixel is installed in index.html, this helper adds additional functionality for tracking specific events

// Meta standard events: https://developers.facebook.com/docs/meta-pixel/reference#standard-events
export const META_EVENTS = {
  // Adding customer payment information during a checkout process. For example, clicking a button to save billing information.
  ADD_PAYMENT_INFO: 'AddPaymentInfo',

  // Adding an item to a shopping cart or basket. For example, clicking an add-to-cart button on a website.
  ADD_TO_CART: 'AddToCart',

  // Adding items to a wishlist. For example, clicking an add-to-wishlist button on a website.
  ADD_TO_WISHLIST: 'AddToWishlist',

  // Submitting information in exchange for a service provided by your business. For example, signing up for an email subscription.
  COMPLETE_REGISTRATION: 'CompleteRegistration',

  // Contact between a customer and your business through phone, SMS, email, chat, or other means.
  CONTACT: 'Contact',

  // Customizing products through a configuration tool or other application owned by your business.
  CUSTOMIZE_PRODUCT: 'CustomizeProduct',

  // Donating funds to your organization or cause.
  DONATE: 'Donate',

  // When a person finds one of your locations via web, with an intention to visit. For example, searching for a product and finding it at one of your local stores.
  FIND_LOCATION: 'FindLocation',

  // The start of a checkout process. For example, clicking a checkout button.
  INITIATE_CHECKOUT: 'InitiateCheckout',

  // A submission of information by a customer with the understanding that they may be contacted at a later date by your business. For example, submitting a form or signing up for a trial.
  LEAD: 'Lead',

  // The completion of a purchase, usually signified by receiving order or purchase confirmation, or a transaction receipt. For example, landing on a thank you or confirmation page.
  PURCHASE: 'Purchase',

  // The booking of an appointment to visit one of your locations.
  SCHEDULE: 'Schedule',

  // A search performed on your website, app or other property. For example, product or travel searches.
  SEARCH: 'Search',

  // The start of a free trial of a product or service you offer. For example, trial subscription.
  START_TRIAL: 'StartTrial',

  // The submission of an application for a product, service or program you offer. For example, a credit card, educational program or job.
  SUBMIT_APPLICATION: 'SubmitApplication',

  // The start of a paid subscription for a product or service you offer.
  SUBSCRIBE: 'Subscribe',

  // A visit to a web page you care about. For example, a product or landing page. View content tells you if someone visits a web page's URL, but not what they do or see on that web page.
  VIEW_CONTENT: 'ViewContent'
};

export const trackMetaEvent = (eventName, params = {}) => {
  const eventNameIsValid = Object.values(META_EVENTS).includes(eventName);
  if (!eventNameIsValid) return;
  else if (typeof window?.fbq !== 'function') return;

  window.fbq('track', eventName, params);
};

/**
 * @param {string} page - The name of the page being viewed, e.g. 'Home', 'Product', 'Cart'
 */
export const trackmetaPageView = page => page && trackMetaEvent(META_EVENTS.VIEW_CONTENT, { page });

export const trackMetaShopperRegistration = shopper =>
  shopper?.id &&
  trackMetaEvent(META_EVENTS.COMPLETE_REGISTRATION, {
    type: 'shopper',
    Shopper_id: shopper.id,
    name: shopper.name,
    email: shopper.email,
    username: shopper.username
  });
export const trackMetaCreatorRegistration = user =>
  user?.id &&
  trackMetaEvent(META_EVENTS.COMPLETE_REGISTRATION, {
    type: 'creator_account',
    User_id: user.id,
    name: user.name,
    email: user.email,
    username: user.username
  });
export const trackMetaCreatorApplication = waitlistUser =>
  waitlistUser?.id &&
  trackMetaEvent(META_EVENTS.SUBMIT_APPLICATION, {
    type: 'creator_waitlist',
    Waitlist_id: waitlistUser.id,
    name: waitlistUser.name,
    email: waitlistUser.email
  });
export const trackMetaBrandRegistration = brand =>
  brand?.id && trackMetaEvent(META_EVENTS.COMPLETE_REGISTRATION, { type: 'brand', Brand_id: brand.id, name: brand.name, domain: brand.domain });
